import { OrganizationType } from '@/bundle/_Opco/types/types';

export const getOrganizationOptions = (organizations: OrganizationType[] = []) => {
  return organizations.map((organization) => {
    return {
      value: organization?.id,
      label: organization?.name,
    };
  });
};
